import lady1 from "../../pictures/lady1.jpeg"
import lady2 from "../../pictures/lady2.jpeg"
import male1 from "../../pictures/male1.jpeg"
import male2 from "../../pictures/male2.jpeg"





export const comments = [
    {
    visitorName : "Elif *****",
    visitorImg : lady1,
    visitorHeader : "Harika Seçim!",
    visitorComment : "Güler yüzlü ve misafirperver ekibinize çok teşekkür ederiz. Eşimle beraber tesisinizde 5 gün misafir olduk ve çok memnun kaldık. Gerek yöresel gerek uluslararası mutfakta son derece başarılı olan mutfak ekibinizi ayrıca tebrik ediyoruz."
    }
    ,
    {
    visitorName : "Betül *****",
    visitorImg : lady2,
    visitorHeader : "Fiyat / Performans!",
    visitorComment : "Güler yüzlü ve misafirperver ekibinize çok teşekkür ederiz. Eşimle beraber tesisinizde 5 gün misafir olduk ve çok memnun kaldık. Gerek yöresel gerek uluslararası mutfakta son derece başarılı olan mutfak ekibinizi ayrıca tebrik ediyoruz."
    },
    {
    visitorName : "Cenk *****",
    visitorImg : male1,
    visitorHeader : "Kusursuz Hizmet!",
    visitorComment : "Güler yüzlü ve misafirperver ekibinize çok teşekkür ederiz. Eşimle beraber tesisinizde 5 gün misafir olduk ve çok memnun kaldık. Gerek yöresel gerek uluslararası mutfakta son derece başarılı olan mutfak ekibinizi ayrıca tebrik ediyoruz."
    }
]

export const mainComment = {
    visitorName : "Hakan *****",
    visitorImg : male2,
    visitorHeader : "Harika Seçim!",
    visitorComment : "Güler yüzlü ve misafirperver ekibinize çok teşekkür ederiz. Eşimle beraber tesisinizde 5 gün misafir olduk ve çok memnun kaldık. Gerek yöresel gerek uluslararası mutfakta son derece başarılı olan mutfak ekibinizi ayrıca tebrik ediyoruz."
    }